import DocumentProcessingJob from "../../features/payslips/services/model/DocumentProcessingJob";
import { SupportedFeatures } from "../../features/payslips/services/model/FeatureConfiguration";

export enum EventType {
  Documents = "DocumentProcessingJob",
}

export type EventSourceOrNull = EventSource | null;
export type ErrorType = "error" | "warning";

export interface SSEContextType {
  listen?: (
    eventType: EventType,
    callback: (event: MessageEvent) => void
  ) => () => void;
}

export interface UseSSEContextInterface {
  loading: boolean;
  connected: boolean;
  error: string | null;
}

export interface SSEProviderProps {
  children: React.ReactNode;
  onErrorMessage?: (message: string, type: ErrorType) => void;
}

export interface SSEConnectionDict extends EventSourceInit {
  timestamp: number;
  token: string;
}

export interface SSEDocumentEvent
  extends Omit<DocumentProcessingJob, "employer_id" | "file_to_process"> {
  last_updated: string;
  processing_sla_deadline: string;
  matching_sla_deadline: string;
  uploading_sla_deadline: string;
  document_type: SupportedFeatures;
  extra_attributes: any;
}

export interface SSEEvent {
  id: number;
  last_updated: string;
  object_type: "DocumentProcessingJob";
  data: SSEDocumentEvent;
}
